export const tableHeader = [
  'Parent Course',
  'Course Name',
  'Description',
  'Status',
  'Actions'
]
